import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider, useTheme } from '@material-ui/core/styles';
import { zIndexScale } from '../../../foundations/zIndex.constants';
// WHY: MUI portals popups at theme.zIndex.modal (1300) which sits below an order-climbing overlay, so raising zIndex.modal for the overlay's content subtree lifts every popup above the whole stack in one place — FullPageModal (IsInModal=false) included.
// WHY: zIndex.tooltip must climb with modal — MUI's scale orders tooltip above modal, and raising modal alone buries a tooltip opened from inside a popup hosted by a modal.
export function OverlayPopupZIndex(param) {
    let { children } = param;
    const outer = useTheme();
    const theme = React.useMemo(()=>_object_spread_props(_object_spread({}, outer), {
            zIndex: _object_spread_props(_object_spread({}, outer.zIndex), {
                modal: zIndexScale.inlinePicker,
                tooltip: zIndexScale.inlinePicker + 1
            })
        }), [
        outer
    ]);
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: theme,
        children: children
    });
}
